import { render, staticRenderFns } from "./WorkflowAnnotation.vue?vue&type=template&id=81a9609e"
import script from "./WorkflowAnnotation.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkflowAnnotation.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports